import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  bottom: 47px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 11px 0 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ", 0px 12px 12px 10px;\n  color: white;\n  display: block;\n  font-size: 12px !important;\n  font-weight: 500;\n  left: ", "%;\n  padding: 3px 8px;\n  border-radius: ", ";\n  position: absolute;\n  top: ", "px;\n  transform: translate(-50%);\n  z-index: 10;\n\n  &::after {\n    content: '';\n    background: url(\"", "\");\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    width: 8px;\n    height: 4px;\n  }\n  transition: all 400ms;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  appearance: none;\n  border-radius: 11.5px;\n  width: 100%;\n  height: ", "px;\n  margin-top: ", ";\n  background: ", ";\n  border: none;\n  z-index: 11;\n\n  /* IE's progress bar is really...progressive \uD83D\uDE0F */\n  &::-webkit-progress-bar {\n    background: ", ";\n    border-radius: 11.5px;\n  }\n\n  &::-webkit-progress-value {\n    background: linear-gradient(\n      to right,\n      ", ",\n      ", "\n    );\n    border-radius: 11.5px;\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    transition: all 400ms;\n  }\n\n  &::-moz-progress-bar {\n    background: linear-gradient(\n      to right,\n      ", ",\n      ", "\n    );\n    border-radius: 11.5px;\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, defaultProps, withProps } from 'recompose';
import roundedTooltip from '../../assets/icons/tooltip-rounded-triangle.svg';
import styled from '../../utils/styling/styled-components';
import { PROGRESS_BAR, PROGRESS_BAR_HELP_TEXT, PROGRESS_BAR_MAX, PROGRESS_BAR_MIN, PROGRESS_BAR_TOOLTIP } from '../../utils/testing/TestIDs';
var enhance = compose(defaultProps({
  max: 100,
  value: 0
}), withProps(function (_ref) {
  var value = _ref.value,
      minLabel = _ref.minLabel,
      maxLabel = _ref.maxLabel,
      max = _ref.max;
  return {
    maxLabel: maxLabel,
    minLabel: minLabel,
    percentage: value / max * 100,
    value: Math.round(value)
  };
}));
var DISTANCE_FROM_BAR = -18;
var TOTAL_TOOLTIP_HEIGHT = DISTANCE_FROM_BAR + 36;
var BAR_HEIGHT = 20;
var TEXT_HEIGHT = 27;
var Container = styled.div(_templateObject(), function (props) {
  return props.text ? "".concat(TOTAL_TOOLTIP_HEIGHT + BAR_HEIGHT + TEXT_HEIGHT) : "".concat(TOTAL_TOOLTIP_HEIGHT + BAR_HEIGHT);
});
var StyledProgressBar = styled.progress(_templateObject2(), BAR_HEIGHT, function (props) {
  return props.withTooltip ? "".concat(TOTAL_TOOLTIP_HEIGHT, "px") : '0';
}, function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.gradients.green[0];
}, function (props) {
  return props.theme.gradients.green[1];
}, function (props) {
  return props.value >= props.max ? '11.5px' : '0';
}, function (props) {
  return props.value >= props.max ? '11.5px' : '0';
}, function (props) {
  return props.theme.gradients.green[0];
}, function (props) {
  return props.theme.gradients.green[1];
}, function (props) {
  return props.value >= props.max ? '11.5px' : '0';
}, function (props) {
  return props.value >= props.max ? '11.5px' : '0';
});
var Tooltip = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.green;
}, function (props) {
  return props.theme.shadows.smDark;
}, function (props) {
  return props.percentage;
}, function (props) {
  return props.theme.borderRadius.small;
}, DISTANCE_FROM_BAR, roundedTooltip);
var ProgressText = styled.p(_templateObject4(), function (props) {
  return props.theme.colors.stone;
});
var ValueContainer = styled.div(_templateObject5(), function (props) {
  return props.withTooltip && 'position: absolute;';
});
var Value = styled.p(_templateObject6(), function (props) {
  return props.theme.colors.stone;
});

var getProgressBar = function getProgressBar(_ref2) {
  var className = _ref2.className,
      max = _ref2.max,
      text = _ref2.text,
      value = _ref2.value,
      withTooltip = _ref2.withTooltip,
      maxLabel = _ref2.maxLabel,
      minLabel = _ref2.minLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, minLabel && maxLabel && /*#__PURE__*/React.createElement(ValueContainer, {
    withTooltip: withTooltip
  }, /*#__PURE__*/React.createElement(Value, {
    "data-testid": PROGRESS_BAR_MIN
  }, minLabel), /*#__PURE__*/React.createElement(Value, {
    "data-testid": PROGRESS_BAR_MAX
  }, maxLabel)), /*#__PURE__*/React.createElement(StyledProgressBar, {
    className: className,
    "data-testid": PROGRESS_BAR,
    max: max,
    withTooltip: withTooltip,
    value: value
  }), text && /*#__PURE__*/React.createElement(ProgressText, {
    "data-testid": PROGRESS_BAR_HELP_TEXT
  }, text));
};

var ContinuousProgressBar = enhance(function (props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.withTooltip ? /*#__PURE__*/React.createElement(Container, {
    text: props.text
  }, /*#__PURE__*/React.createElement(Tooltip, {
    "data-testid": PROGRESS_BAR_TOOLTIP,
    percentage: props.percentage
  }, props.label), getProgressBar(props)) : /*#__PURE__*/React.createElement(React.Fragment, null, getProgressBar(props)));
});
export { ContinuousProgressBar };